<template>
    <div class="bizcomp-assets box">
        <el-tabs v-model="activeType" class="tab">
            <el-tab-pane name="assets" label="专户历史净值查询">
                <div class="filter-box">
                    <div>日期区间：</div>
                    <date-picker
                        :date="dateSet"
                        sep-text="-"
                        style="width: 310px"
                        v-on:date-get="dateInterval"
                    />
                    <div style="margin-left: 10px">基金名称：</div>
                    <div>
                        <el-select
                            v-model="fundcode"
                            placeholder="选择基金"
                            class="select-class"
                            v-on:change="handleSelect"
                        >
                            <el-option
                                v-for="item in fundList"
                                :key="item.fundcode"
                                :label="item.fundname"
                                :value="item.fundcode"
                            ></el-option>
                        </el-select>
                    </div>
                    <el-button
                        size="small"
                        style="background-color: var(--color-primary); color: #ffffff"
                        v-on:click.prevent="searchDateRec"
                    >
                        查询
                    </el-button>
                    <el-button
                        size="small"
                        style="border-color: var(--color-primary); color: var(--color-primary)"
                        v-on:click.prevent="clearQry"
                    >
                        重置
                    </el-button>
                </div>

                <div v-if="chart.color">
                    <div class="chart-title">产品净值走势图</div>
                    <chart :option="chart" :ref-v="'currency'" />
                </div>

                <el-row v-if="navList.length <= 0 && hasLoad" class="no-funds">
                    <el-col :span="12" :offset="8">
                        <span class="no-funds-img" />
                        <div class="no-funds-box">
                            <p>暂无数据</p>
                        </div>
                    </el-col>
                </el-row>
                <el-table
                    v-else-if="hasLoad"
                    :data="navList"
                    class="tab-list-tit"
                    :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
                >
                    <el-table-column
                        prop="fundname"
                        label="基金代码"
                        width="200"
                        class-name="fund-offset"
                    >
                        <template slot-scope="scope">
                            <div style="color: #999999">
                                {{ scope.row.fundcode }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="净值日期" align="center">
                        <template slot-scope="scope">
                            <span>{{ $util.fmtDate(scope.row.navdate) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位净值" align="center">
                        <template slot-scope="scope">
                            <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计净值" align="center">
                        <template slot-scope="scope">
                            <span>{{ $util.fmtNum(scope.row.totalnav, 4) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row v-if="allPage > 0" class="page-box">
                    <el-pagination
                        :page-size="Number(conf.PAGE_SIZE)"
                        :current-page.sync="curPage"
                        layout="->, total, prev, pager, next"
                        :total="Number(allPage)"
                        v-on:current-change="swichPage"
                    />
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import datePicker from "@/components/form/datePicker";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import chart from "@/components/misc/chart.vue";

export default {
    name: "FundNav",
    components: {
        datePicker,
        chart
    },
    data() {
        return {
            activeType: "assets", // tab类型
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间",
                val: []
            },
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            fundcode: "", // 搜索基金代码
            navList: [], // 净值列表
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            hasLoad: false, // 是否已经查询数据
            conf: {}, // 初始化配置文件内容
            chart: {},
            fundList: [] // 下拉基金
        };
    },
    async mounted() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.conf = this.$util.getConfig().const;
        this.endDate = this.nowDate;
        this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
        const _x = this.$util.fmtDate(this.beginDate);
        const _y = this.$util.fmtDate(this.endDate);
        this.dateSet.val = [_x, _y];

        await this.getAsset();

        if (this.fundcode) {
            await this.getChartNavRec();
            await this.getNavRec();
        } else {
            this.hasLoad = true;
        }
    },
    methods: {
        async getAsset() {
            const res = await fundApi.qrySpecialAsset({
                producttype: "@",
                keyword: "",
                pageSize: 10,
                pageNum: 1,
                assetshowtype: "0",
                specialassetflag: "1"
            });
            const returnList = res.data.returnList;
            if (returnList && returnList.length > 0) {
                this.fundList = returnList.map((item) => {
                    return {
                        fundcode: item.fundcode,
                        fundname: item.fundname
                    };
                });

                if (this.$route.query && this.$route.query.fundcode) {
                    this.fundcode = this.$route.query.fundcode;
                } else {
                    this.fundcode = this.fundList[0].fundcode;
                }
            }
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 搜索时间区间记录
        async searchDateRec() {
            if (!this.fundcode) {
                this.$message.info("请先选择基金名称后再查询");
                return false;
            }

            this.curPage = 1;
            this.pageoffset = "1";
            await this.getChartNavRec();
            await this.getNavRec();
        },
        // 获取新一页数据
        swichPage(val) {
            this.pageoffset = val;
            this.getNavRec();
        },
        // 选中建议项
        async handleSelect() {
            this.pageoffset = 1;
            await this.getChartNavRec();
            await this.getNavRec();
        },
        // 获取基金列表
        async getFundList(val, cb) {
            const res = await fundApi.getFundLists({
                keyword: val,
                pagesize: "20",
                pagenum: "1",
                tradingmethod: this.$util.getConfig().systemtype
            });
            if (res.data) {
                cb(res.data.list || []);
            }
        },
        async getNavRec(val, cb) {
            const _x = {
                startdate: this.beginDate,
                enddate: this.endDate,
                fundcode: this.fundcode,
                isasc: "0",
                pagesize: cb ? "10" : this.pagecount,
                pagenum: val ? "1" : this.pageoffset
            };
            const res = await fundApi.getNavHistoryList(_x);
            this.hasLoad = true;
            if (res.data) {
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.navList = res.data.list;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, res.data.list);
                }
            }
        },
        async getChartNavRec() {
            this.chart = {};
            const _x = {
                startdate: this.beginDate,
                enddate: this.endDate,
                fundcode: this.fundcode,
                isasc: "1",
                pagesize: 99999,
                pagenum: 1
            };
            const res = await fundApi.getNavHistoryList(_x);
            if (res.data) {
                const navRs = res.data.list;
                if (navRs.length > 0) {
                    let _obj = [];
                    let _objUnit = [];
                    let _xV = [];

                    let minVal = navRs[0].nav;

                    for (let i = 0; i < navRs.length; i++) {
                        _xV.push(this.$util.fmtDate(navRs[i].navdate));
                        _obj.push(this.$util.fmtNum(navRs[i].nav, 4));
                        _objUnit.push(this.$util.fmtNum(navRs[i].totalnav, 4));

                        if (minVal > navRs[i].nav) {
                            minVal = navRs[i].nav;
                        }

                        if (minVal > navRs[i].totalnav) {
                            minVal = navRs[i].totalnav;
                        }
                    }
                    this.chart = {
                        xData: _xV,
                        color: ["#e99400", "#008cd4"],
                        name: ["单位净值", "累计净值"],
                        data: [_obj, _objUnit],
                        minVal: minVal
                    };
                }
            }
        },
        async clearQry() {
            this.dateSet.val = ["", ""];
            this.beginDate = "";
            this.endDate = "";
            this.fundcode = "";
            this.navList = [];
            this.chart = [];
            this.allPage = 0;
        }
    }
};
</script>

<style lang="scss">
.box {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .file-button {
        position: absolute;
        width: 100px;
        height: 40px;
        top: 15px;
        right: 25px;
        background: #f1f1f1;
        color: #666666;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }

    .filter-box {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        gap: 16px;
        padding: 20px;
        .input-search {
            width: 320px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                color: #999999;
            }
            .el-input__inner {
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .el-input--mini .el-input__inner {
            height: 32px;
        }
    }

    .chart-title {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #333333;
        margin-top: 20px;
    }
}
</style>
